// OccurrenceRegistry.js

const OccurrenceRegistry = (() => {
  // Estados válidos
  const VALID_STATES = new Set(['pending', 'success', 'fail']);

  // Objeto interno (NO se expone directamente)
  const occurrences = {};

  /**
   * Registra una nueva ocurrencia
   */
  const registerOccurrence = (uuid) => {
    if (!uuid) {
      throw new Error('uuid is required');
    }

    occurrences[uuid] = {
      state: 'pending',
      updatedAt: Date.now(),
    };
  };

  /**
   * Actualiza el estado de una ocurrencia
   */
  const updateOccurrence = (uuid, newState, data) => {
    if (!occurrences[uuid]) {
      throw new Error(`Occurrence ${uuid} not registered`);
    }

    if (!VALID_STATES.has(newState)) {
      throw new Error(`Invalid state: ${newState}`);
    }

    occurrences[uuid].state = newState;
    occurrences[uuid].data = data;
    occurrences[uuid].updatedAt = Date.now();
  };

  /**
   * Devuelve el estado actual
   */
  const getOccurrenceState = (uuid) => {
    return occurrences[uuid]?.state;
  };

  /**
   * Espera a que una ocurrencia cambie a success o fail
   */
  const waitForOccurrence = (
    uuid,
    {
      intervalMs = 100,
      timeoutMs = 29000,
    } = {}
  ) => {
    return new Promise((resolve, reject) => {
      const startTime = Date.now();

      const timer = setInterval(() => {
        const state = occurrences[uuid]?.state;
        const data = occurrences[uuid]?.data;

        if (!state) {
          clearInterval(timer);
          reject(new Error(`Occurrence ${uuid} not found`));
          return;
        }

        if (state === 'success') {
          clearInterval(timer);
          resolve({ uuid, state, data });
          return;
        }

        if (state === 'fail') {
          clearInterval(timer);
          reject({ uuid, state });
          return;
        }

        if (Date.now() - startTime > timeoutMs) {
          clearInterval(timer);
          reject(new Error(`Timeout waiting for occurrence ${uuid}`));
        }
      }, intervalMs);
    });
  };

  return Object.freeze({
    registerOccurrence,
    updateOccurrence,
    getOccurrenceState,
    waitForOccurrence,
  });
})();

export default OccurrenceRegistry;
